import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { SubscribeDialog } from '@/components/organisms/subscribe-dialog'
import { useSubscription } from '@/contexts/subscription-context'

import { Button } from './ui/button'

/**
 * A small, always-visible reminder at the bottom of the sidebar for a trial or expired
 * account, so subscribing is never more than the current screen's dead end away.
 *
 * Owner-only, same reasoning as the banner and the dialog it opens: showing this — or a
 * button that would fail — to someone who isn't the one paying is just noise.
 */
export const SubscribeSidebarCard = () => {
  const { t } = useTranslation()
  const { isOwner, isReadOnly, isTrial } = useSubscription()
  const [isOpen, setIsOpen] = useState(false)

  if (!isOwner || (!isTrial && !isReadOnly)) return null

  return (
    <div className="group-data-[collapsible=icon]:hidden rounded-xl bg-brand-gran p-3.5 text-white">
      <p className="text-sm font-bold leading-snug">
        {t(isReadOnly ? 'subscribeSidebarCard.expiredHeading' : 'subscribeSidebarCard.trialHeading')}
      </p>
      <p className="mt-1 text-xs leading-snug text-white">{t('subscribeSidebarCard.body')}</p>
      <Button className="mt-3 w-full" onClick={() => setIsOpen(true)} size="sm">
        {t('subscribeSidebarCard.cta')}
      </Button>
      <SubscribeDialog onOpenChange={setIsOpen} open={isOpen} />
    </div>
  )
}
